import { ReducerCreators } from '@reduxjs/toolkit';
import { AudiencesState } from '../types';

export const setAllAttendeesTotal = (create: ReducerCreators<AudiencesState>) =>
  create.reducer<number>((state, action) => {
    state.allAttendees.total = action.payload;
  });
